var $ = require('jquery');

module.exports = {
	init: function () {
		// Add aria attributes to pagination links
		$(document).on('facetwp-loaded', function () {
			// Remove any existing aria-current attributes
			$('.facetwp-type-pager .facetwp-page').removeAttr('aria-current');

			// Add aria-current="page" to the active page
			$('.facetwp-type-pager .facetwp-page.active').attr('aria-current', 'page');

			// Add aria-hidden to dots
			$('.facetwp-type-pager .facetwp-page.dots').attr('aria-hidden', 'true');

			// Add descriptive aria-labels to prev/next buttons
			$('.facetwp-type-pager .facetwp-page.prev').each(function () {
				var prevPage = $(this).attr('data-page');
				if (prevPage) {
					$(this).attr('aria-label', 'Go to previous page: page ' + prevPage);
				}
			});

			$('.facetwp-type-pager .facetwp-page.next').each(function () {
				var nextPage = $(this).attr('data-page');
				if (nextPage) {
					$(this).attr('aria-label', 'Go to next page: page ' + nextPage);
				}
			});

			// Add aria-labels to numbered page links
			$('.facetwp-type-pager .facetwp-page[data-page]')
				.not('.prev, .next, .active')
				.each(function () {
					var pageNum = $(this).attr('data-page');
					$(this).attr('aria-label', 'Go to page ' + pageNum);
				});
		});
	},
};
